import React from 'react';
import styled, { keyframes } from 'styled-components';
import config from '../config/config';

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
`;

const Logo = styled.img`
  width: 140px;
  height: auto;
  animation: ${spinAnimation} 3s ease-in-out infinite;
`;

const Loader = () => {
  return (
    <LoaderContainer>
        <Logo src={`${config.documentsUrl}logos/logo_resized.png`} alt="Logo" height="140" />
    </LoaderContainer>
  );
};

export default Loader;
